<template>
  <div
    class="markBox"
    id="main-bar-line"
    :style="{ width: width + 'px', height: height + 'px' }"
  ></div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/legend");

export default {
  name: "main-bar-line",
  props: {
    volume_data: [Array, Object],
    forecastTimeNode: Date,
    width: Number,
    height: Number,
    is_loading: Boolean,
  },
  data() {
    return {
      chart: {},
    };
  },
  watch: {
    volume_data(new_val) {
      this.chart.showLoading();
      this.volume_data = new_val;
      this.draw();
    },
    is_loading(new_val) {
      new_val ? this.chart.showLoading() : this.chart.hideLoading();
    },
  },
  mounted() {
    this.chart = echarts.init(document.getElementById("main-bar-line"));
    this.chart.showLoading();
  },
  computed: {},
  methods: {
    draw() {
      const _this = this;
      const data = _this.volume_data;
      if (null == data || "undefined" == typeof data || "" == data) {
        this.chart.hideLoading();
        return;
      }
      const timenode = _this.forecastTimeNode;
      var legendsData = [];
      var xAxisData = [];
      var seriesData = [];
      for (let item of data) {
        let date = new Date(item.volumeDate);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        if (legendsData.indexOf(year.toString()) === -1) {
          legendsData.push(year.toString());
        }
        if (xAxisData.indexOf(month + "月") === -1) {
          xAxisData.push(month + "月");
        }
      }
      for (let item of legendsData) {
        let sdata = {
          name: item,
          type: "bar",
          barWidth: 12,
          barCategoryGap: 30,
          data: [],
        };
        for (let dataItem of data) {
          if (new Date(dataItem.volumeDate).getFullYear() == item) {
            sdata.data.push(dataItem.volume);
          }
        }
        seriesData.push(sdata);
      }
      var thisyear = Math.max.apply(null, legendsData);
      var yoyData = [];
      var yoyForecast = [];
      for (let item of data) {
        let date = new Date(item.volumeDate);
        let year = date.getFullYear();
        if (year === thisyear) {
          if (date <= timenode) {
            yoyData.push(item.yoY.replace("%", "") / 1);
            yoyForecast.push("-");
          } else {
            yoyForecast.push(item.yoY === "-" ? "-" : item.yoY.replace("%", "") / 1);
            if (date.getMonth() == timenode.getMonth()) {
              yoyData.push(item.yoY.replace("%", "") / 1);
            }
          }
        }
      }
      seriesData.push({
        name: "同比",
        type: "line",
        smooth: true,
        yAxisIndex: 1,
        data: yoyData,
      });
      seriesData.push({
        name: "预测",
        type: "line",
        smooth: true,
        yAxisIndex: 1,
        //smooth: false,   //关键点，为true是不支持虚线，实线就用true
        itemStyle: {
          normal: {
            lineStyle: {
              type: "dotted", //'dotted'虚线 'solid'实线
            },
          },
        },
        data: yoyForecast,
      });

      legendsData.push("同比");
      legendsData.push("预测");

      let yoyMin = _this.getMinValue(yoyData);
      let yoyMax = _this.getMaxValue(yoyData);
      let yoyFMin = _this.getMinValue(yoyForecast);
      let yoyFMax = _this.getMaxValue(yoyForecast);

      yoyMin = yoyMin <= yoyFMin ? yoyMin : yoyFMin;
      yoyMax = yoyMax >= yoyFMax ? yoyMax : yoyFMax;

      //   const dataMin = _this.getMinValue(seriesData[0].data);
      const dataMax = _this.getMaxValue(seriesData[0].data);
      // 指定图表的配置项和数据
      var option = {
        color: ["#C3C3C3", "#00578F", "#5D7092", "#5D7092"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          show: true,
          formatter: (params) => {
            let list = [];
            if (params && params.length > 0) {
              list.push(
                '<span style="font-size:12px;color:#6e7079;margin-left:2px">' +
                  params[0]?.name +
                  '</span><div style="clear:both"></div>'
              );
            }
            let listItem = "";
            for (let param of params) {
              if (param.value !== "-" && param.value !== 0) {
                if (param.seriesName === "预测" && params.length === 4) {
                  continue;
                }
                list.push(
                  param.marker +
                    '<span style="font-size:12px;color:#6e7079;margin-left:2px">' +
                    (param.seriesName === "同比" || param.seriesName === "预测"
                      ? param.seriesName.split("").join(" ")
                      : param.seriesName) +
                    "</span>：" +
                    '<span style="font-size:12px;margin-left:5px;' +
                    (param.seriesName === "同比" || param.seriesName === "预测"
                      ? "color:" + (Number(param.value) > 0 ? "green" : "red") + ""
                      : "") +
                    ';">' +
                    param.value.toLocaleString() +
                    (param.seriesName === "同比" || param.seriesName === "预测"
                      ? "%"
                      : "") +
                    "</span>" +
                    '<div style="clear:both"></div>'
                );
              }
            }
            listItem = list.join("");
            return listItem;
          },
        },
        legend: {
          bottom: 10,
          left: "center",
          data: legendsData,
          // icon: "rect"
        },
        xAxis: {
          data: xAxisData,
          axisLine: {
            lineStyle: {
              color: "#DDDDDD",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#333333",
            },
          },
        },
        yAxis: [
          {
            type: "value",
            name: "（辆）",
            nameTextStyle: {
              color: "#999999",
            },
            axisLine: {
              lineStyle: {
                color: "#DDDDDD",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#333333",
              },
            },
            min: 0,
            max: _this.getMaxAxis(dataMax),
            splitNumber: 5,
            interval: parseInt(_this.getMaxAxis(dataMax) / 5),
            scale: false,
          },
          {
            type: "value",
            name: "同比",
            nameTextStyle: {
              color: "#999999",
            },
            axisLine: {
              lineStyle: {
                color: "#DDDDDD",
              },
            },
            axisLabel: {
              formatter: "{value}%",
              textStyle: {
                color: "#333333",
              },
            },
            min: _this.getMinMaxY2(yoyMin, yoyMax) * -0.5,
            max: _this.getMinMaxY2(yoyMin, yoyMax),
            splitNumber: 5,
            interval: parseInt(
              (_this.getMinMaxY2(yoyMin, yoyMax) -
                _this.getMinMaxY2(yoyMin, yoyMax) * -0.5) /
                5
            ),
          },
        ],
        series: seriesData,
      };
      // this.chart.clear();
      this.chart.setOption(option, true);
      this.chart.hideLoading();
      this.chart.dispatchAction({
        type: "showTip",
        seriesIndex: 0,
        dataIndex: 0,
      });
    },
    getMaxValue(arr) {
      var arrCopy = arr.slice(0);
      for (var i = arrCopy.length; i >= 0; i--) {
        if (!(typeof arrCopy[i] == "number")) {
          arrCopy.splice(i, 1);
        }
      }
      const max = Math.max.apply(null, arrCopy);
      return Math.ceil(max / 9.5) * 10;
    },
    getMinValue(arr) {
      var arrCopy = arr.slice(0);
      for (var i = arrCopy.length; i >= 0; i--) {
        if (!(typeof arrCopy[i] == "number")) {
          arrCopy.splice(i, 1);
        }
      }
      const min = Math.min.apply(null, arrCopy);
      return Math.floor(min / 10) * 10;
    },
    getMaxAxis(m) {
      let singleLine = Math.pow(10, m.toString().length - 2) * 5;
      let maxLine = singleLine * (parseInt(m / singleLine) + 1);
      return maxLine;
    },
    getMinMaxY2(min, max) {
      //第三条线为0线，maxline.maxline/2,-maxline/2,-maxline,-1.5maxline
      //比较min,max绝对值，以绝对值大的来计算整体刻度,至少加10%.不要到顶
      let mabs = Math.abs(max) > Math.abs(min) ? Math.abs(max) : Math.abs(min);
      let maxLine = parseInt((mabs + 10) / 10) * 10;
      return maxLine;
    },
  },
};
</script>
